/**
 * @license lucide v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const AlignRight = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M21 12H9" }],
    ["path", { d: "M21 18H7" }],
    ["path", { d: "M21 6H3" }]
  ]
];

export { AlignRight as default };
//# sourceMappingURL=align-right.js.map
